angular.module('zc.zenclerkS')
  .component('zcsInterestWidgetSettings', {
    templateUrl: '/templates/zenclerk_s/sites/interest_widget/interest_widget_settings.html',
    bindings: {
      project: '<'
    },
    controller: zcsInterestWidgetSettingsController
  });

zcsInterestWidgetSettingsController.$inject = ['$translate', 'Campaign', 'InterestWidget', 'Template'];
function zcsInterestWidgetSettingsController($translate, Campaign, InterestWidget, Template) {
  const vm = this;

  vm.$onInit = () => {
    vm.campaign = undefined;
    vm.currentView = 'pc';

    vm.selectView = selectView;
    vm.changeIwStatus = changeIwStatus;
    vm.saveCampaign = saveCampaign;
    vm.isSaving = false;

    Campaign.all({ projectId: vm.project.id })
      .then(campaigns => {
        const iwCampaigns = _.filter(campaigns, c => c.interest_widget_id);

        _.each(iwCampaigns, iwCampaign => {
          InterestWidget.get(vm.project.apikey, iwCampaign.interest_widget_id).then(iw => {
            iwCampaign.interest_widget = _.merge({}, iw);
          });
        });

        if(iwCampaigns.length) {
        // Separate PC and SP for now - ideal would be that they are shown as one
          vm.campaignPC = _.find(iwCampaigns, c => c.campaign_device === 'pc');
          vm.campaignSP = _.find(iwCampaigns, c => c.campaign_device === 'sp');

          if(!vm.campaignPC && vm.campaignSP) {
            selectView('sp');
          } else {
            selectView('pc');
          }

          setTemplate(vm.campaignPC);
          setTemplate(vm.campaignSP);
        }
      });
  };

  function selectView(device) {
    if(device === 'pc') {
      vm.currentView = 'pc';
      vm.campaign = vm.campaignPC;
    } else {
      vm.currentView = 'sp';
      vm.campaign = vm.campaignSP;
    }
    setTemplate(vm.campaign);
  }

  function setTemplate(campaign) {
    if(!campaign) return;

    Template.all(vm.project.id)
      .then(templates => {
        campaign.template = _.find(templates, template => template.name === campaign.template_type);
      });
  }

  function changeIwStatus(status) {
    if(vm.campaign.interest_widget.status === 'enable') {
      if(!confirm($translate.instant('sites.interestWidget.interestWidgetSettings.haishin_ga_tomarimasu'))) {
        return;
      }
    }

    vm.campaign.interest_widget.status = status;
    InterestWidget.update(vm.project.apikey, vm.campaign.interest_widget.id, vm.campaign.interest_widget)
      .then(interestWidget => {
        vm.campaign.interest_widget = interestWidget;
      });
  }

  function saveCampaign() {
    vm.isSaving = true;
    Campaign.update({ projectId: vm.project.id, campaignId: vm.campaign.id }, vm.campaign)
      .then(campaign => {
        vm.campaign = _.merge(vm.campaign, campaign);
        vm.isSaving = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/interest_widget/interest_widget_settings.js